import {Injectable, NgZone} from '@angular/core';
import { Router } from '@angular/router';
import {CookieService} from 'angular2-cookie/core';
import {Usuario} from '../../usuarios/domain/usuario';

@Injectable()
export class AuthenticationService {
    projectKey = 'investigadores_';
    idKey = this.projectKey + 'id';
    tokenKey = this.projectKey + 'token';
    idiomasKey = this.projectKey + 'idiomas';
    cuentaKey = this.projectKey + 'cuenta';
    rolKey = this.projectKey + 'rol';

    constructor(private router: Router, public cookies: CookieService, private ngZone: NgZone) { }

    login(usuario: Usuario) {
        this.setCookies(usuario);
        this.ngZone.run(() => {
            this.router.navigate(['/es/' + usuario.rol]);
        });
    }
    logout() {
        this.removeCookies();
        this.router.navigate(['/']);
    }
    public setCookies(usuario) {
        this.cookies.put(this.idKey, usuario.id);
        this.cookies.put(this.tokenKey, usuario.token);
        this.cookies.put(this.idiomasKey, usuario.idiomas);
        this.cookies.put(this.cuentaKey, usuario.cuenta);
        this.cookies.put(this.rolKey, usuario.rol);
    }
    public getCookies(key) {
        switch (key) {
            case 'id':
                return this.cookies.get(this.idKey);
            case 'token':
                return this.cookies.get(this.tokenKey);
            case 'idiomas':
                return this.cookies.get(this.idiomasKey);
            case 'cuenta':
                return this.cookies.get(this.cuentaKey);
            case 'rol':
                return this.cookies.get(this.rolKey);
        }
    }
    public removeCookies() {
        this.cookies.remove(this.idKey);
        this.cookies.remove(this.tokenKey);
        this.cookies.remove(this.idiomasKey);
        this.cookies.remove(this.cuentaKey);
        this.cookies.remove(this.rolKey);
    }

    public isAuthenticated(): boolean {
        return this.cookies.get(this.tokenKey) != undefined;
    }

    urlRolValidate(url) {
        const regex = new RegExp('\\/' + this.getCookies('rol'));
        const result =  regex.test(url);
        if (!result) {
            this.redirigirPanelControl();
        }
    }

    redirigirPanelControl() {
        this.router.navigate(['/es/' + this.getCookies('rol')]);
    }

}


// WEBPACK FOOTER //
// ./src/app/core/services/authentication.service.ts